class Effect {
    constructor(numVariants) {
        this.numVariants = numVariants;
        this.variant = 0;
    }

    nextVariant() {
        // Cycle through variants
        this.variant = (this.variant + 1) % this.numVariants;
    }

    async setup(_init) {
        // noop
    }

    async update(options) {
        this.variant = options.variant;
    }

    async cleanup() {
        // noop
    }

    apply(form, context, tracklets) {
        throw new Error("Method 'apply' must be implemented.");
    }
}

export default Effect;
